import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ADC_ERROR_CODE_ENUM } from '@shared/enums';
import { AuthService } from '@shared/services';

export const jwtLoginGuard = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
    const router = inject(Router);
    const authService = inject(AuthService);

    const jwtToken: string = route.queryParams.jwt;

    if (route.outlet !== 'primary' || !jwtToken) {
        return of(true);
    }

    return authService.loginByAnyToken(jwtToken).pipe(
        map(() => false),
        catchError((error) => {
            switch (error.code) {
                case ADC_ERROR_CODE_ENUM.INTEGRATION_NO_PACKAGE:
                    return of(router.createUrlTree(['no-package']));

                case ADC_ERROR_CODE_ENUM.INTEGRATION_PACKAGE_TRIAL_ENDED:
                    return of(router.createUrlTree(['trial-ended']));

                case ADC_ERROR_CODE_ENUM.PACKAGE_PURCHASE_INTERRUPTED:
                    return of(router.createUrlTree(['package-purchase']));
            }

            return of(router.createUrlTree([401]));
        }),
    );
};
